import { render, staticRenderFns } from "./TheadPercentPockets.vue?vue&type=template&id=8e762ad8"
import script from "./TheadPercentPockets.vue?vue&type=script&lang=js"
export * from "./TheadPercentPockets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports